import { FiltersMap } from '@wix/bex-core';

export interface DragAndDropCategoriesProps<F extends FiltersMap> {
  /**
   * By default, drag and drop works only without filters.
   * To enable drag and drop with filters, pass an array of filters to this prop.
   * The functionality will then work only for the specified filters, and to enable without filters, you must pass an empty array.
   * For more information, see the [Drag and Drop Overview](//?path=/story/features-sort-drag-and-drop--overview).
   * @external
   */
  dragAndDropCategories?: (keyof F)[][] | null;
}
